<template>
	<div>
    <div class="skenleton" v-if="!isMobile && (head || modules)">
      <el-row type="flex" justify="center" v-if="head">
        <el-col :span="16" style="margin-top: 47px; position: relative">
          <span class="gray" style="height: 65px; width: 168px; margin-right: 20px;"></span>
          <span class="gray" style="height: 36px; width: 100px;"></span>
          <p class="gray" style="height: 18px; width: 300px; margin-top: 10px;"></p>
          <p class="gray" style="height: 18px; width: 114px; margin-top: 10px; margin-bottom: 10px"></p>
          <span class="gray" style="height: 18px; width: 72px; margin-right: 6px;"></span>
          <span class="gray" style="height: 18px; width: 72px; margin-right: 6px;"></span>
          <span class="gray" style="height: 18px; width: 72px;"></span>
          <ul class="list">
            <li class="item gray"></li>
            <li class="item gray"></li>
            <li class="item gray"></li>
            <li class="item gray"></li>
            <li class="item gray"></li>
            <li class="item gray"></li>
          </ul>
        </el-col>
      </el-row>
      <p class="line el-button--primary" v-if="head"></p>
      <el-row type="flex" justify="center" v-if="modules">
        <el-col :span="16">
          <div class="section-wrap">
            <span class="gray" style="height: 20px; width: 20px; margin-right: 5px;"></span>
            <span class="gray" style="height: 20px; width: 69px;"></span>
            <p class="line"></p>
            <div style="margin-bottom: 60px;">
              <span class="gray" style="height: 200px; width: 200px; margin-right: 20px; float:left;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 536px; margin-bottom: 7px;"></span>
              <span class="gray" style="height: 18px; width: 401px;"></span>
              <span class="gray" style="height: 20px; width: 20px; margin-right: 5px;"></span>
            </div>
            <span class="gray" style="height: 20px; width: 20px; margin-right: 5px;"></span>
            <span class="gray" style="height: 20px; width: 69px;"></span>
            <p class="line"></p>
            <p class="gray" style="width: 351px; height: 18px; margin-bottom: 7px;"></p>
            <p class="gray" style="width: 755px; height: 18px; margin-bottom: 7px;"></p>
            <p class="gray" style="width: 515px; height: 18px; margin-bottom: 50px;"></p>
            <span class="gray" style="height: 20px; width: 20px; margin-right: 5px;"></span>
            <span class="gray" style="height: 20px; width: 69px;"></span>
            <p class="line"></p>
            <p class="gray" style="width: 351px; height: 18px;"></p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="isMobile && (head || modules)" class="bgcolor search-content">
      <template v-if="head">
        <p class="bgcolor content-p-header1"></p>
        <p class="bgcolor content-p-header2"></p>
        <p class="bgcolor content-p-header3"></p>
        <p class="bgcolor content-p-header4"></p>
        <el-row type="flex" justify="space-around">
          <el-col :span="6" :offset="3">
            <span class="bgcolor content-span-header1"></span>
          </el-col>
          <el-col :span="6">
            <span class="bgcolor content-span-header2"></span>
          </el-col>
          <el-col :span="6">
            <span class="bgcolor content-span-header3"></span>
          </el-col>
        </el-row>
        <p class="bgcolor separate-top"></p>
        <el-row type="flex" justify="space-around">
          <el-col :span="6" :offset="3">
            <p class="bgcolor content-p-body1"></p>
          </el-col>
          <el-col :span="6">
            <p class="bgcolor content-p-body2"></p>
          </el-col>
          <el-col :span="6">
            <p class="bgcolor content-p-body3"></p>
          </el-col>
          <el-col :span="6">
            <p class="bgcolor content-p-body4"></p>
          </el-col>
        </el-row>
        <p class="separate-middle"></p>
      </template>
      <template v-if="modules">
        <span class="bgcolor content-span-body1"></span>
        <span class="bgcolor content-span-body2"></span>
        <p class="bgcolor separate-down"></p>
        <div class="footer">
          <p class="bgcolor content-p-footer1"></p>
          <p class="bgcolor content-p-footer2"></p>
          <p class="bgcolor content-p-footer3"></p>
          <p class="bgcolor content-p-footer4"></p>
          <p class="bgcolor content-p-footer5"></p>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SkeletonIndex',
  data () {
    return {
    }
  },
  props: {
    head: {
      type: Boolean,
      default () {
        return true
      }
    },
    modules: {
      type: Boolean,
      default () {
        return true
      }
    },
    isMobile: {
      type: Boolean,
      default () {
        return false
      }
    }
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/skeleton/index.vue